<template>
  <div>
    <DashboardWidgetLayout :loading="isSavableStateLoading"
      widget-id="internal-qa-offers-dashboard-full"
      widget-title="Super Team Dashboard"
      :show-filter-panel="true"
      :widget-icon="['fas', 'user-group']">
      <template #dashboardSidebarNav>
        <div>
          <MultiSelectInput 
            v-model="filterParams.super_team_dashboard_configuration_id"
            name="superTeamDashboard"
            label="Select Dashboard"
            :options="superTeamDashboardStore.available_dashboards"
            label-key="name"
            placeholder="Select Dashboard"
            value-key="id"
            @update:modelValue="showSelectedDashboard()"/>
        </div>
        <template v-if="appStore.currentUser.hasPermission('internal_dashboard_unfinished_business')">
          <router-link :to="{ name: 'internal-dashboard-unfinished-business' }"
            class="nav-link card-header-btn py-0 dashboard-sidenav-link">
            <span style="padding-right: 0.5rem">Unfinished Business</span>
          </router-link>
        </template>
      </template>
      <template #filters>
        <form class="row" @submit.prevent v-if="selectedDashboard">
          <div class="col-12">
            <div class="row">
              <MultiSelectInput v-model="filterParams.user_id"
                name="user"
                label="Assigned To"
                :options="[ { id:'unassigned', name_to_display:'Unassigned' }, ...selectedDashboard.assignableUsers ]"
                label-key="name_to_display"
                value-key="id"
                col-style="form-group-standard-column" />
              <MultiSelectInput v-model="filterParams.transplant_center_ids"
                name="txc"
                label="TxC "
                :options="selectedDashboard.transplantCenters"
                label-key="code"
                value-key="id"
                :multiple="true"
                :show-toggle-all="false"
                col-style="form-group-standard-column" />
              <MultiSelectInput v-model="filterParams.organ_group_ids"
                name="organ_group"
                label="Organ Group "
                :options="selectedDashboard.organGroups"
                label-key="name"
                value-key="id"
                :multiple="true"
                :show-toggle-all="false"
                col-style="form-group-standard-column" />
          
              <MultiSelectInput v-model="filterParams.status_ids"
                name="status"
                label="Status "
                :options="selectedDashboard.statuses"
                label-key="name"
                value-key="id"
                :multiple="true"
                :show-toggle-all="false"
                col-style="form-group-standard-column" />
            </div> 
            <div class="row">
              <div class="form-group-standard-column">
                <label>Match Code</label>
                <input columnType="text" v-model="filterParams.match_code" class="form-control">
              </div>
              <div class="form-group-standard-column">
                <label>Donor Code</label>
                <input columnType="text" v-model="filterParams.donor_code" class="form-control">
              </div>
              <SingleSelect v-model="filterParams.is_case"
                name="case"
                label="Service Level"
                :options="serviceLevelOptions"
                label-key="label"
                value-key="value"
                :show-clear="true"
                col-style="form-group-standard-column"
                @change=""/>
              <div class="form-group-standard-column">
                <p class="p-label">
                  Include Dismissed
                </p>
                <div class="form-check form-check-inline">
                  <input id="include_dismissed"
                    v-model="filterParams.show_dismissed"
                    aria-labelledby="include_dismissed"
                    type="checkbox" class="form-check-input">
                  <label for="include_dismissed" class="form-check-label">
                    <span>Yes</span>
                  </label>
                </div>
              </div> 
            </div>   
            <div class="row">
              <div class="form-group-standard-column form-group-date-time">
                <div>
                  <label for="from_date">
                    <span>Offer Date From:</span>
                  </label>
                  <input id="from_date" ref="from_date" v-model="filterParams.fromDate" class="form-control" type="date">
                </div>
                <div>
                  <label for="from_time">
                    <span>Offer Time From:</span>
                  </label>
                  <input id="from_time" ref="from_time" v-model="filterParams.fromTime" class="form-control" type="time">
                </div>
              </div>
              <div class="form-group-standard-column form-group-date-time">
                <div>
                  <label for="to_date">
                    <span>Offer Date To:</span>
                  </label>
                  <input id="to_date" ref="to_date" v-model="filterParams.toDate" class="form-control" type="date">
                </div>
                <div>
                  <label for="to_time">
                    <span>Offer Time To:</span>
                  </label>
                  <input id="to_time" ref="to_time" v-model="filterParams.toTime" class="form-control" type="time">
                </div>
              </div>
              <MultiSelectInput v-model="filterParams.checklist_status"
                v-if="appStore.currentUser.hasPermission('internal_match_checklists')"
                name="checklist_status"
                label="Checklist Status:"
                :options="[ {code:'', label:'All'}, {code: 'not_started', label:'Not Started'}, ...selectedDashboard.checklistStatuses]"
                label-key="label"
                value-key="code"
                :multiple="true"
                :show-toggle-all="false"
                col-style="form-group-standard-column" />
               
            </div>
          </div>
          <div class="col-12">  
            <ActionToolbar :component-state="currentState" 
              :error-message="formError"  
              tertiary-enabled
              primary-button-text="Filter"
              secondary-button-text="Clear"
              @primary-click="filterData()"
              @secondary-click="() => { getRowData({resetFilters: true}); }">
                <template #tertiary-button-area>
                  <div class="dropdown d-flex align-items-center">
                    <a href="#" @click.prevent="saveView(true)" class="btn btn-outline-primary mr-3">Create view</a>
                    <a v-if="currentView !== 'Default'" href="#" @click.prevent="saveView(false)" class="btn btn-outline-primary mr-3">Update view</a>
                    <a class="btn btn-secondary dropdown-toggle" @click.prevent href="#" role="button" data-toggle="dropdown" aria-expanded="false">
                      Views
                    </a>
                    <div class="dropdown-menu dropdown-menu-scrollable">
                      <div
                        v-for="name in Object.keys(superTeamDashboardStore.availableViews).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))"
                        :key="name"
                        class="dropdown-item d-flex align-items-center justify-content-between view-dropdown-item">
                        <a href="#" @click.prevent="loadView(name)" class="flex-grow-1 view-name-link">{{ name }}</a>
                        <span class="view-actions ml-2">
                          <a href="#" title="Rename view" class="mr-2" @click.stop.prevent="renameView(name)">
                            <font-awesome-icon :icon="['fas', 'pen']" />
                          </a>
                          <a v-if="name !== currentView" href="#" title="Delete view" class="text-danger" @click.stop.prevent="deleteView(name)">
                            <font-awesome-icon :icon="['fas', 'trash']" />
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
            </ActionToolbar>
          </div>
        </form>
      </template>
      <template #content>  
        <form class="row" @submit.prevent>
            <div class="col-12">
              <div class="row">
                <div class="float-right ml-auto mr-2" v-if="selectedDashboard">
                  <span tooltip="Current View"><font-awesome-icon :icon="['fas', 'eye']" /><b>: {{ currentView }}</b></span>
                </div>
              </div>                        
            </div>
        </form>    
        <div class="row">
          <div class="col-12" v-if="selectedDashboard">
            <DataTable
              ref="internalSuperTeamDashboardTable"
              show-gridlines
              reorderable-columns
              @column-reorder="onColReorder"
              @column-resize-end="onColReSize"
              :key="datatableKey"
              resizable-columns 
              removable-sort
              columnResizeMode="expand"
              scrollHeight="70vh" 
              scrollable
              row-hover
              :lazy="true"
              @sort="handleSortChange"
              @table-row-select="selectedOfferRows"
              table-style="min-width: 50rem"
              :loading="isSavableStateProcessing || isSavableStateProcessing" 
              edit-mode="cell"
              v-model:selection="selectedRows"
              :expandedRows="selectedDashboard.failedRows"
              :value="selectedDashboard.visibleRows">
              <template #header>
                <div class="d-flex justify-content-between w-100 align-items-center">
                  <button class="btn btn-outline-primary d-inline-block" @click.prevent="enableBulkEdit">
                    <font-awesome-icon :icon="['fas', (bulkEdit ? 'edit' : 'pen')]" />
                    <span v-if="bulkEdit" style="padding-right: 0.5rem">Disable Select Mode</span>
                    <span v-else style="padding-right: 0.5rem">Enable Select Mode</span>
                  </button>
                  <button v-if="bulkEdit && selectedRows" class="btn btn-outline-primary d-inline-block ml-4" @click="clearSelectedRows" :disabled="selectedRows.length === 0">
                    <font-awesome-icon :icon="['fas', 'square-check']" />
                    <span style="padding-right: 0.5rem">Clear Selection</span>
                  </button>

                  <span class="d-flex m-auto align-items-center px-3 flex-wrap">
                    Records Found: <span class="font-emphasize">{{ selectedDashboard.totalCount }}</span> |  Showing: <span class="font-emphasize ">{{ selectedDashboard.visibleRows.length }}</span>
                  </span>

                
                  <button class="btn btn-outline-dark d-inline-block ml-3" href="" @click.prevent="showManageColumns = !showManageColumns">
                    <font-awesome-icon :icon="['fas', 'caret-up']" v-if="showManageColumns" />
                    <font-awesome-icon :icon="['fas', 'caret-down']" v-else />
                      <span>Manage columns</span>
                  </button>
                  
                </div>
                <ColumnConfig :tableColumns="selectedDashboard.allColumns" @configSaved="updateDashboardColumns" v-if="showManageColumns"></ColumnConfig>
              </template>
              <Column selection-mode="multiple" 
                header-style="width: 3rem" 
                :frozen="true"
                column-key="bulk_edit"
                align-frozen="left"
                :reorderable-column="false"
                v-if="bulkEdit"/>
              <Column v-for="(col, idx) in selectedDashboard.visibleColumns" 
                :key="idx"
                :field="col.field" 
                :column-key="col.identifier"
                align-frozen="left"
                :frozen="col.isFrozen" 
                :sortable="col.isSortable"
                :sort-field="col.sortField"
                :style="col.width && !col.wasResized ? `min-width: ${col.width};` : ''"                  
                :header="col.header">
                <template #body="{ data, index }">
                  <template v-if="col.identifier === 'assigned_to_full_name'">
                    <a target="_blank" href="#"  @click.prevent="showModalFor(data, ActionModals.OFFER_ASSIGNMENTS)" class="table-link">
                      <font-awesome-icon class="desktop-action" :icon="['fas', 'edit']" />
                      <span>{{ data.assignment && data.assignment.assigned_to ? data.assignment.assigned_to.full_name : 'Unassigned' }}</span>
                    </a>
                  </template>
                  <template v-else>
                    <span class="p-col-span" :class="{ 'column-prevent-wrap': col.identifier === 'match_donor_code', 'column-date-wrap': col.identifier === 'match_offer_date'}">
                    <font-awesome-icon v-if="col.statusIcon && col.identifier === 'match_donor_code' && donorStatus(data) == 'successful'" :icon="['fas', 'circle-check']" style="color: green;" title="Successful"/>
                    <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'match_donor_code' && donorStatus(data) == 'errored'" :icon="['fas', 'circle-exclamation']" style="color: red;" title="Errored"/>
                    <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'match_donor_code' && donorStatus(data) == 'ongoing'" :icon="['fas', 'spinner']" style="color: blue;" title="On going"/>
                    <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'match_calculated_final_disposition_code_applicable' && !data.final_disposition_approved" :icon="['fas', 'asterisk']" style="color: red;" title="Not approved"/>
                    <font-awesome-icon v-else-if="col.statusIcon && col.identifier === 'service_level_applicable' && !data.service_level_approved" :icon="['fas', 'asterisk']" style="color: red;" title="Not approved"/>
                    <span v-if="col.statusIcon" style="padding:2px !important;"></span>
                      {{SuperTeamDashboardRow.getNestedValue(data,col.field)}}
                    </span>
                  </template>
                </template>
              </Column>
              <Column class="btn-2-icon-group" :frozen="true"  align-frozen="right" column-key="frozen_col_1">
                <template #body="slotProps">
                  <div class="d-flex">
                  <template v-if="slotProps.data.dismissed">
                    <a href="#" title="Activate" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="performMatchAction('activate',slotProps.data)">
                      <font-awesome-icon class="desktop-action" :icon="['fas', 'circle-plus']" /><span class="mobile-action">Activate</span>
                    </a>
                  </template>
                  <template v-else>
                    <a href="#" title="Dismiss Offer" class="action btn btn-fill btn-outline-danger mx-2" @click.prevent="performMatchAction('dismiss',slotProps.data)">
                      <font-awesome-icon class="desktop-action" :icon="['far', 'circle-xmark']" /><span class="mobile-action">Dismiss Offer</span>
                    </a>
                  </template>

                    <template v-if="slotProps.data.case">
                      <a href="#" :title="removeCaseText(slotProps.data)" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="performMatchAction('unmake_case', slotProps.data)">
                        <font-awesome-icon v-if="slotProps.data.performing_action_unmake_case" :icon="['fas', 'fa-spinner']" class="fa-spin" />
                        <font-awesome-icon v-else class="desktop-action" :icon="['fas', 'circle-minus']" /><span class="mobile-action">{{ removeCaseText(slotProps.data) }}</span>
                      </a>
                    </template>
                    <template v-else>
                      <a href="#" title="Make Case" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="performMatchAction('make_case', slotProps.data)">
                        <font-awesome-icon v-if="slotProps.data.performing_action_make_case" :icon="['fas', 'fa-spinner']" class="fa-spin" />
                        <font-awesome-icon v-else class="desktop-action" :icon="['fas', 'house-medical-flag']" /><span class="mobile-action">Make Case</span>
                        
                      </a>
                    </template>
                    </div>
                  </template>
                </Column>
                <Column class="btn-4-icon-group" style="overflow: visible !important" :frozen="true"  align-frozen="right" column-key="frozen_col_2" :reorderable-column="false">
                  <template #body="slotProps">
                    <div class="d-flex">
                      <a v-if="appStore.currentUser.hasPermission('internal_match_decline_offer')" href="#" title="Decline" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="showModalFor(slotProps.data, ActionModals.DECLINE)">
                        <font-awesome-icon class="desktop-action" :icon="['fas', 'ban']" /><span class="mobile-action">Decline</span>
                      </a>
      
                      <a href="#" title="Details" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="showModalFor(slotProps.data, ActionModals.DONOR_DETAILS)">
                        <font-awesome-icon class="desktop-action" :icon="['fas', 'file-lines']" /><span class="mobile-action">Details</span>
                      </a>
      
                      <a href="#" :title="!slotProps.data.coordinator_note.note ? `Add Notes` : `Notes`" class="action btn btn-fill btn-outline-primary mx-2" @click.prevent="showModalFor(slotProps.data, ActionModals.NOTES)">
                        <font-awesome-icon class="desktop-action" :icon="['fas', !slotProps.data.coordinator_note.note ? 'plus-square' : 'comment-alt']" /><span class="mobile-action">Notes</span>
                      </a>
                      <div v-if="appStore.currentUser.hasPermission('internal_match_communication_templates') || appStore.currentUser.hasPermission('internal_match_manage_alternative_notifications') || appStore.currentUser.hasPermission('internal_match_checklists')" id="plugin-dropdown" class="dropdown">
                        <button type="button" class="btn btn-outline-primary" @click="openPopup($event, slotProps.data)">
                          <font-awesome-icon :icon="['fas', 'caret-down']" />
                          <span class="sr-only">click to select</span>
                        </button>
                      </div>
                    </div>
                    <MatchAppliedTags :tags="slotProps.data.tags" />
                  </template>
                </Column>
                <template #footer v-if="bulkEdit" >    
                  <button v-if="selectedRows" :disabled="!selectedRows.length" class="btn btn-success mr-3" @click.prevent="showBulkOfferAssignmentModal()">
                    Transfer
                  </button>   
                </template>
              </DataTable>
            
            <Pagination 
              v-if="selectedDashboard.totalPages > 1 || filterParams.limit"
              :current_page="selectedDashboard.currentPage" 
              :page_count="selectedDashboard.totalPages"
              :records_per_page="filterParams.limit"
              :disabled="isSaving"
              :enable_rows_per_page="true"
              @updatePage="setPage"
              @updateRowCount="setLimit"/>
            </div>
          </div>
        <Popover class="dashboard-plugin-dropdown" ref="internalSuperTeamDashboard">
          <div>
            <a 
              autofocus
              v-if="appStore.currentUser.hasPermission('internal_match_communication_templates')" 
              class="dropdown-item" target="_blank" 
              :href="goToTemplate(selectedItem).href">
                Comms Templates
                <font-awesome-icon :icon="['fas', 'up-right-from-square']" />
              </a>
              <button 
                v-if="appStore.currentUser.hasPermission('internal_match_manage_alternative_notifications')" 
                class="dropdown-item" type="button" 
                @click="showModalFor(selectedItem, ActionModals.NOTIFICATIONS)">
                Notifications
              </button>
              <a 
                v-if="appStore.currentUser.hasPermission('internal_match_quick_quote')" 
                class="dropdown-item" 
                target="_blank"
                :href="selectedItem.logisticsQuickQuoteURL">
                Quick Quote
                <font-awesome-icon :icon="['fas', 'up-right-from-square']" />
              </a>
              <router-link 
                v-if="appStore.currentUser.hasPermission('internal_match_checklists')" 
                class="dropdown-item" 
                target="_blank" 
                :to="{ name: 'internal-match-checklists', params: { match_id: selectedItem.id} }">
                Checklists
                <font-awesome-icon :icon="['fas', 'up-right-from-square']" />
              </router-link>
              <button 
                v-if="appStore.currentUser.hasPermission('internal_match_tags')" 
                class="dropdown-item"
                type="button" 
                @click="showModalFor(selectedItem, ActionModals.TAGS)">
                  Tags
              </button>
              <button 
                v-if="appStore.currentUser.hasPermission('admin_troubleshoot_matches')" 
                class="dropdown-item"
                type="button" 
                @click="showModalFor(selectedItem, ActionModals.OFFER_INFO)">
                Offer Info
              </button>
          </div>
        </Popover>
      </template>
    </DashboardWidgetLayout>
    <BulkAssignmentsModal ref="bulkAssignmentsModal"
       :matches="selectedRows"
       :users="superTeamDashboardStore.selectedDashboard && superTeamDashboardStore.selectedDashboard.assignableUsers.filter(item => !item.disabled)"
        @close="modalClosed()" />
    <!-- Render modal component dynamically -->
    <component :is="requestedModal" 
      v-if="requestedModal" 
      :ref="requestedModal"
      :match-id="selectedMatch && selectedMatch.id"
      :donor-id="selectedMatch && selectedMatch.donor.id"
      :users="superTeamDashboardStore.selectedDashboard && superTeamDashboardStore.selectedDashboard.assignableUsers.filter(item => !item.disabled)"
      :dashboard-id="selectedDashboard"
      @close="modalClosed()"
      @tags-updated="getRowData()"/>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';
import DataTable, { DataTableRowReorderEvent } from 'primevue/datatable';
import Column from 'primevue/column';
import DashboardWidgetLayout from "@/src/components/shared/DashboardWidgetLayout.vue";
import {useAppCoreStore} from "@/src/stores/app-core";
import { useSuperTeamDashboardStore } from '@/src/stores/dashboards/super-team-dashboards';
import VueDatePicker from '@vuepic/vue-datepicker';
import MultiSelectInput from "@/src/components/shared/FormComponents/MultiSelectInput.vue";
import SingleSelect from "@/src/components/shared/FormComponents/SingleSelect.vue";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import { TableColumn } from "@/src/models/dashboard/table-column";
import ColumnConfig from '@/src/components/buckeye-coordinator-area/dashboards/ColumnConfig.vue';
import ActionToolbar from '@/src/components/shared/ActionToolbar.vue';
import { SuperTeamDashboardRow } from '@/src/models/dashboard/super_teams/super-team-dashboard-row';
import Pagination from '@/src/components/shared/Pagination.vue';
import NotesModal from "@/src/components/buckeye-coordinator-area/modals/CoordinatorNotesModal.vue";
import {APIRoute, EP, APIRouteFull} from "@/src/endpoints";
import beApiClient from "@/src/be-api-client";
import AssignmentsModal from "@/src/components/buckeye-coordinator-area/dashboards/super-teams/modals/AssignmentsModal.vue";
import BulkAssignmentsModal from "@/src/components/buckeye-coordinator-area/dashboards/super-teams/modals/BulkAssignmentsModal.vue";
import DeclineModal from "@/src/components/buckeye-coordinator-area/modals/DeclineModal.vue";
import DonorDetailsModal from "@/src/components/buckeye-coordinator-area/modals/DonorDetailsModal.vue";
import NotificationsModal from "@/src/components/buckeye-coordinator-area/modals/NotificationsModal.vue";
import Popover from 'primevue/popover';
import MatchAppliedTags from '@/src/components/shared/MatchAppliedTags.vue';
import MatchAppliedTagModal from "@/src/components/buckeye-coordinator-area/modals/MatchAppliedTagModal.vue";
import OfferInfoModal from "@/src/components/buckeye-coordinator-area/modals/OfferInfoModal.vue";


const ActionModals = {
  DECLINE: 'decline-modal',
  NOTES: 'notes-modal',
  DONOR_DETAILS: 'donor-details-modal',
  NOTIFICATIONS: 'notifications-modal',
  OFFER_ASSIGNMENTS: 'assignments-modal',
  TAGS: 'match-applied-tag-modal',
  OFFER_INFO: 'offer-info-modal'
}

const Mode = {
  VIEW: 'view',
  EDIT: 'edit',
}

export default {
  components: {
    NotesModal,
    ActionToolbar,
    DataTable,
    DashboardWidgetLayout,
    Column,
    VueDatePicker,
    SingleSelect,
    MultiSelectInput,
    ColumnConfig,
    Pagination,
    AssignmentsModal,
    BulkAssignmentsModal,
    DeclineModal,
    DonorDetailsModal,
    NotificationsModal,
    OfferInfoModal,
    Popover,
    MatchAppliedTags,
    MatchAppliedTagModal
  },
  setup() {
    const appStore = useAppCoreStore();
    const superTeamDashboardStore = useSuperTeamDashboardStore();

    return {
      appStore,
      superTeamDashboardStore
    }
  },
  mixins: [savableStateMixin],
  data() {
    return {
      ActionModals,
      requestedModal: null,
      csrfToken: $("meta[name='csrf-token']").attr("content"),
      showManageColumns: false,
      datatableKey: 'initial-key',
      isSaving: false,
      isExporting: false,
      filterParams: {
        super_team_dashboard_configuration_id: null,
        match_code: null,
        donor_code: null,
        status_ids: null,
        checklist_status: null,
        date_from: null,
        time_from: null,
        date_to: null,
        time_to: null,
        fromDate: null,
        fromTime:null,
        toDate: null,
        toTime: null,
        show_dismissed: null,
        organ_group_ids: null,
        transplant_center_ids: null,
        user_id: null,
        page: 1,
        limit: 50
      },
      SuperTeamDashboardRow: new SuperTeamDashboardRow,
      currentView: 'Default',
      selectedMatch: null,
      selectedRows: [],
      bulkEdit: false,
      serviceLevelOptions: [
        { label: 'All', value: '' },
        { label: 'Triage + Handle', value: 'false' },
        { label: 'Case', value: 'true' }
      ],
      selectedItem: null
    }
  },
  async mounted() {
    this.appStore.setAppBreadcrumbs([
      {
        to: { name: 'internal-dashboards-root' },
        text: 'Dashboards'
      },
      {
        text: 'Super Team Dashboard'
      }
    ]);

    await this.performAsyncLoading(async () => {
      await this.superTeamDashboardStore.loadSuperTeamDashboards();
      await this.superTeamDashboardStore.loadViews(this.$route.params.id);

      if(this.$route.params.id) {
        this.filterParams.super_team_dashboard_configuration_id = this.$route.params.id;
        await this.superTeamDashboardStore.loadSuperTeamDashboard(this.filterParams);
      }
    });
    this.$nextTick(() => {
      this.setupColumnResizerDragListener();
    });
  },
  beforeUnmount() {
    // Reset all relevant state to initial values
    this.currentView = 'Default';
    this.filterParams = {
      match_code: null,
      donor_code: null,
      txc_code: null,
      date_to: null,
      date_from: null,
      show_dismissed: null,
      is_case: null,
      status_ids: null,
      user_id: null
    };
    this.showManageColumns = false;
  },
  watch: {
    datatableKey() {
      // Re-attach listener when table is re-rendered
      this.$nextTick(() => {
        this.setupColumnResizerDragListener();
      });
    }
  },
  computed: {
    selectedDashboard() {
      if(!this.filterParams.super_team_dashboard_configuration_id) return null;
      
      return this.superTeamDashboardStore.selectedDashboard;
    },
    user() {
      return this.appStore.currentUser;
    },
    userPermissions() {
      return this.appStore.currentUser ? this.appStore.currentUser.userPermissions : null;
    }
  },
  methods: {
    async showSelectedDashboard() {
      if(!this.filterParams.super_team_dashboard_configuration_id) {
        this.$router.push({ name: 'internal-dashboard-super-teams'});
      } else {
        const selectedDashboardId = this.filterParams.super_team_dashboard_configuration_id;
        this.clearFilters();
        this.filterParams.super_team_dashboard_configuration_id = selectedDashboardId;
        this.currentView = 'Default';
        this.$router.push({ name: 'internal-dashboard-super-teams_edit', params: { id: selectedDashboardId }});
        await this.performAsyncProcessing(() => {
          this.superTeamDashboardStore.loadViews(this.filterParams.super_team_dashboard_configuration_id);
          return this.superTeamDashboardStore.loadSuperTeamDashboard(this.filterParams);
        });
      }
    },
    async filterData() {
      // Reset to first page when loading new data
      this.filterParams.page = 1;
      this.getRowData();
    },
    async getRowData(resetFilters: false) {
      await this.performAsyncProcessing(() => {
        if(resetFilters) {
          this.filterParams = {
            super_team_dashboard_configuration_id: this.$route.params.id,
            match_code: null,
            donor_code: null,
            status_ids: null,
            date_from: null,
            time_from: null,
            date_to: null,
            time_to: null,
            fromDate: null,
            fromTime:null,
            toDate: null,
            toTime: null,
            checklist_status: null,
            show_dismissed: null,
            organ_group_ids: null,
            transplant_center_ids: null,
            user_id: null,
            page: 1,
            limit: 50
          };
        }
        const offer_date_from = this.filterParams.fromDate && this.filterParams.fromTime ? new Date(`${this.filterParams.fromDate}T${this.filterParams.fromTime}`) : this.filterParams.fromDate ? this.filterParams.fromDate : '';
        const offer_date_to = this.filterParams.toDate && this.filterParams.toTime ? new Date(`${this.filterParams.toDate}T${this.filterParams.toTime}`) : this.filterParams.toDate ? this.filterParams.toDate : '';
        this.filterParams.date_from = offer_date_from;
        this.filterParams.date_to = offer_date_to;
        return this.superTeamDashboardStore.loadSuperTeamDashboardRows(this.filterParams);        
      });
    },
    goToTemplate(data) {
      const donor = data.donor.id;
      const match = data.id;
      const txc = data.transplant_center_id
      const organGroup = data.organ.organ_group_id

      return this.$router.resolve({ 
        name: 'internal-match-comms-templates', 
        params: { match_id: match }
      });
    },
    performMatchAction(action, match) {
      match[`performing_action_${action}`] = true; 
      const endpoint = APIRoute(EP.matches[action],{match_id: match.id});
      if(!endpoint) alert(`Unable to perform ${action} on a match. Please check!`);
      beApiClient.patch(endpoint).then((response) => {
        this.getRowData()
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        match[`performing_action_${action}`] = false;
      });
    },
    removeCaseText(match) {
      let text = "Remove from Case"
      if(match.omnilife_case_status && match.omnilife_case_status.last_integration_status) {
        if(match.omnilife_case_status.last_integration_status === 'error') {
          text += " (OL: Failed)"
        } else {
          text += " (OL: Created)"
        }
      }

      return text;
    },
    showModalFor(match, modalType) {
      this.selectedMatch = match
      this.requestedModal = modalType;
      this.$refs.internalSuperTeamDashboard.hide();
      this.$nextTick(() => {
        let modal = this.$refs[modalType];
        if(!modal) {
          alert(`No modal found for ${modalType}`);
          return;
        }

        modal.showModal();
      });
    },
    modalClosed() {
      this.selectedMatch = null;
      this.selectedRows = null;
      this.getRowData();
    },
    async setPage(page: number) {
      // Block pagination while saving
      if (this.isSaving) {
        return;
      }
      
      this.filterParams.page = page
      await this.getRowData();
    },
    async setLimit(rowCount: number) {
      // Block pagination while saving
      if (this.isSaving) {
        return;
      }
      
      this.filterParams.limit = rowCount
      this.filterParams.page = 1
      await this.getRowData();
    },
    updateDashboardColumns(updatedColumns: Array<TableColumn>) {
      this.selectedDashboard.allColumns = updatedColumns;
    },
    onColReorder(evt: DataTableRowReorderEvent) {      
      // Get only visible columns for reordering
      const visibleColumns = this.selectedDashboard.allColumns.filter((c: TableColumn) => c.isVisible);

      // Scroll position handling
      const table = this.$refs.internalSuperTeamDashboardTable?.$el;
      const scrollable = table.querySelector('.p-datatable-table-container');
      const currentScrollLeft = parseInt(scrollable?.scrollLeft?.toString() || '0', 10);
      const resetScrollPosition = () => {
        this.$nextTick(() => {
          // Reset the scrollLeft to the current position to avoid jumping
          const table = this.$refs.internalSuperTeamDashboardTable?.$el; // must redefine table to work
          const scrollable = table.querySelector('.p-datatable-table-container');
          if (scrollable) {
            scrollable.scrollLeft = currentScrollLeft;
          }
        });
      };

      // If moving the frozen column.
      if (evt.dragIndex > visibleColumns.length - 1) {
        this.forceRerenderTable()
        resetScrollPosition();
        return;
      }

      const movedColumn = visibleColumns[evt.dragIndex];
      if (!movedColumn) { // sanity check
        this.forceRerenderTable();
        return;
      }
      
      // Move the column in the visible columns array
      const reorderedVisibleColumns = [...visibleColumns];
      reorderedVisibleColumns.splice(evt.dragIndex, 1);
      reorderedVisibleColumns.splice(evt.dropIndex, 0, movedColumn);

      console.log(reorderedVisibleColumns);
      // Make a list of visible column positions
      const visiblePositions: number[] = [];
      this.selectedDashboard.allColumns.forEach((col, idx) => {
        if (col.isVisible) {
          visiblePositions.push(idx);
        }
      });
      
      // Create a new array that preserves hidden column positions
      const newDashboardColumns = [...this.selectedDashboard.allColumns];
      reorderedVisibleColumns.forEach((col, idx) => {
        const positionIndex = visiblePositions[idx];
        newDashboardColumns[positionIndex] = col;
        col.position = positionIndex;
      });

      this.selectedDashboard.allColumns = newDashboardColumns;
      
        this.forceRerenderTable();
        resetScrollPosition();

    },
    onColReSize(event) {
      const delta = event.delta;
      const th = event.element as HTMLTableCellElement;

      const thText = th.innerText.trim();
      const colIdx = this.selectedDashboard.allColumns.findIndex(col => col.header && col.header.trim() === thText);
      if (colIdx !== -1) {
        let currentWidth = parseInt(this.selectedDashboard.allColumns[colIdx].width, 10);
        let newWidth = isNaN(currentWidth) ? th.offsetWidth : Math.round(currentWidth + delta)
        this.selectedDashboard.allColumns[colIdx].width = `${newWidth}px`;
        
        this.selectedDashboard.allColumns[colIdx].wasResized = true;
      }
    },
    isActionDisabled(data) {
      return !data.dirty;
    },
    donorStatus(data) {
      return data.donor.processing_status;
    },
    // Setup a column resizer drag listener for column width resizing
    setupColumnResizerDragListener() {
      const table = this.$refs.internalSuperTeamDashboardTable?.$el;
      if (!table) return;
      const resizers = table.querySelectorAll('.p-datatable-column-resizer');
      resizers.forEach(resizer => {
        resizer.onpointerdown = null;
        resizer.addEventListener('pointerdown', this.onColumnResizerPointerDown, { passive: false });
      });
    },
    onColumnResizerPointerDown(e) {
      if (e.button !== 0) return;
      const resizer = e.target;

      // on dragging
      const onPointerMove = (e) => {
        this.onColumnResizeDragging(resizer);
      };
      const onPointerUp = () => {
        // remove listeners after dragging
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
      };

      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
    },
    onColumnResizeDragging(resizer) {
      // Remove the min-width style to allow resizing
      const th = resizer.closest('th');
      if (th && th.style) {
        th.style.minWidth = '';
      }
    },
    forceRerenderTable() {
      this.selectedDashboard.allColumns.forEach(col => {
        col.wasResized = false; // Reset the resize flag
      });
      // Force re-render the table by changing the key
      this.datatableKey = `${new Date()}`;
    },
    clearSelectedRows() {
      this.selectedRows = [];
    },
    // Offer Assignments
    selectedOfferRows(data) {
      this.selectedRows = data;
    },
    showBulkOfferAssignmentModal() {
      this.$refs.bulkAssignmentsModal.showModal();
    },
    enableBulkEdit() {
      this.bulkEdit = !this.bulkEdit;
      this.selectedRows = [];
      const dt = this.$refs.internalSuperTeamDashboardTable;
      this.$nextTick(() => {
      
        if (this.bulkEdit && dt.d_columnOrder) {

          const key = 'bulk_edit'; // muli select column key
          const order = dt.d_columnOrder;
          
          const index = order.indexOf(key);     
          if (index > 0) {
              order.splice(index, 1); 
              order.unshift(key); 
          } else if (index === -1) {
              order.unshift(key);
          }
          dt.d_columnOrder = order;
        }
      })
    },
    handleSortChange(params) {
      this.filterParams.sort_field = params.sortField;
      switch(params.sortOrder) {
        case 1:
          this.filterParams.sort_type = 'asc';
          break;
        case -1:
          this.filterParams.sort_type = 'desc';
          break;
        default:
          this.filterParams.sort_type = null;
      }
      
      this.getRowData();
    },
    openPopup(event, data) {
      this.$refs.internalSuperTeamDashboard.toggle(event); // Call toggle method on the single Popover instance, using the current event as target
      this.selectedItem = data; // Update the popover content data
    },
    async saveView(forceNew = false) {
      let viewName;
      if (forceNew || this.currentView == 'Default') {
        viewName = prompt('Give the view a name');
        if (!viewName) {
          alert('You must provide a name!');
          return;
        } else if (this.superTeamDashboardStore.availableViews[viewName]) {
          alert(`A view with the name "${viewName}" already exists! Please choose a different name.`);
          return;
        } 
      } else {
        viewName = this.currentView;
        if (!confirm(`Are you sure you want to update view: ${viewName}?`)) {
          this.setSavableStateIdle();
          return;
        }
      }
      this.superTeamDashboardStore.availableViews[viewName] = {
        filterParams: { ...this.filterParams },
        
        // only the required user ui properties.
        dashboardColumns: this.selectedDashboard.allColumns.map(col => ({
          identifier: col.identifier,
          position: col.position,
          width: col.width,
          isFrozen: col.isFrozen,
          isVisible: col.isVisible
        }))
      };
      try {
        this.setSavableStateProcessing();
        await this.superTeamDashboardStore.saveView(this.superTeamDashboardStore.availableViews, viewName, this.$route.params.id);
        this.currentView = viewName;
        await this.superTeamDashboardStore.loadViews(this.$route.params.id);
        this.setSavableStateIdle();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async deleteView(viewName: string) {
      if (!viewName || !this.superTeamDashboardStore.availableViews[viewName]) return;
      if (viewName === this.currentView) return;
      if (!confirm(`Are you sure you want to delete view: ${viewName}?`)) return;

      try {
        this.setSavableStateProcessing();
        await this.superTeamDashboardStore.deleteView(viewName, this.$route.params.id);
        await this.superTeamDashboardStore.loadViews(this.$route.params.id);
        this.setSavableStateIdle();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async renameView(viewName: string) {
      if (!viewName || !this.superTeamDashboardStore.availableViews[viewName]) return;

      const newName = prompt(`Rename view "${viewName}" to:`, viewName);
      if (newName === null) return; // cancelled
      const trimmed = newName.trim();
      if (!trimmed) {
        alert('You must provide a name!');
        return;
      }
      if (trimmed === viewName) return;
      if (this.superTeamDashboardStore.availableViews[trimmed]) {
        alert(`A view with the name "${trimmed}" already exists! Please choose a different name.`);
        return;
      }

      try {
        this.setSavableStateProcessing();
        await this.superTeamDashboardStore.renameView(viewName, trimmed, this.$route.params.id);
        if (this.currentView === viewName) this.currentView = trimmed;
        await this.superTeamDashboardStore.loadViews(this.$route.params.id);
        this.setSavableStateIdle();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async loadView(viewName: string) {
      if(!viewName || !this.superTeamDashboardStore.availableViews[viewName]) return; // Nothing to do
      this.setSavableStateProcessing();
      const view = this.superTeamDashboardStore.availableViews[viewName];
      this.currentView = viewName;
      this.clearFilters();
      
      for(const k in view.filterParams) {
        if(this.filterParams[k]) {
          this.filterParams[k] = view.filterParams[k];
        } else {
          this.filterParams[k] = view.filterParams[k];
        }
      }
      
      // Load the dashboard columns from the view and compare with current dashboardColumns.
      const uiPreferencesDefaults = {
        position: undefined,
        width: undefined,
        isFrozen: false,
        isVisible: true,
        wasResized: false,
      };
      const loadedDashboardColumns = view.dashboardColumns.map((colFromView) => {
        const currentCol = this.selectedDashboard.allColumns.find(c => c.identifier === colFromView.identifier) || {};

        // Start with all currentCol properties, reset the defaults, then merge from view
        const mergedCol = { ...currentCol, ...uiPreferencesDefaults };
        Object.keys(uiPreferencesDefaults).forEach(key => {
          if (colFromView.hasOwnProperty(key)) {
            mergedCol[key] = colFromView[key];
          }
        });
        mergedCol.identifier = colFromView.identifier;

        return new TableColumn(mergedCol);
      });

      // 1. Loaded columns by identifier
      const loadedColMap = Object.fromEntries(loadedDashboardColumns.map(col => [col.identifier, col]));

      // 2. Find the largest position value
      let maxPosition = loadedDashboardColumns.reduce((max, col) => (typeof col.position === 'number' && col.position > max ? col.position : max), -1);

      // 3. Add new qa dashboard columns that are not in the view.
      this.selectedDashboard.allColumns.forEach(col => {
        if (!loadedColMap[col.identifier]) {
          const newCol = new TableColumn({ ...col, position: ++maxPosition, isVisible: false });
          loadedDashboardColumns.push(newCol);
        }
      });

      // 4. Remove columns from the view that no longer exist.
      const currentIdentifiers = new Set(this.selectedDashboard.allColumns.map(col => col.identifier));
      for (let i = loadedDashboardColumns.length - 1; i >= 0; i--) {
        if (!currentIdentifiers.has(loadedDashboardColumns[i].identifier)) {
          loadedDashboardColumns.splice(i, 1);
        }
      }

      // 5. Sort and normalize positions
      loadedDashboardColumns.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
      loadedDashboardColumns.forEach((col, idx) => {
        col.position = idx;
      });

      this.selectedDashboard.allColumns = loadedDashboardColumns;
  
      this.filterData();
      this.setSavableStateIdle();
      this.forceRerenderTable();
    },
    clearFilters() {
      this.filterParams = {
          super_team_dashboard_configuration_id: this.$route.params.id,
          match_code: null,
          donor_code: null,
          status_ids: null,
          checklist_status:null,
          date_from: null,
          time_from: null,
          date_to: null,
          time_to: null,
          fromDate: null,
          fromTime:null,
          toDate: null,
          toTime: null,
          show_dismissed: null,
          organ_group_ids: null,
          transplant_center_ids: null,
          user_id: null,
          page: 1,
          limit: 50
        };
    }  
  }
}
</script>
<style>
.p-select-dropdown-extend {
  justify-content: normal;
  width: 150px;
}
.row-edited {
  background-color: #fffbe6 !important; /* yellow for unsaved changes */
}

.row-saved {
  animation: fadeHighlight 2s forwards;
  background-color: #d4edda !important; /* green success background */
}

.row-saving {
  background-color: #f0f0f0 !important;
  pointer-events: none;
  opacity: 0.6;
}

.row-failed {
  background-color: #f8d7da !important;
  color: #721c24;
}

.qa-error-box {
  padding: 1rem;
  border-left: 4px solid #f87171;
  background-color: #fef2f2;    
  color: #b91c1c;                 
  font-size: 0.95rem;
}

.p-datatable-resizable-table > .p-datatable-tbody > tr > td:not(:has(> span.column-prevent-wrap)) {
  white-space: pre-wrap !important;
}

.p-datatable-resizable-table > .p-datatable-tbody > tr > td span.p-col-span {
  padding: 0 !important;
}
 
.p-datatable-resizable-table > .p-datatable-tbody > tr > td .p-select {
  width: 100%;
}


.column-prevent-wrap {
  padding: 0;
}

.column-date-wrap {
  display: block;
  width: 90px;

}

@keyframes fadeHighlight {
  0%   { background-color: #d4edda !important; }
  100% { background-color: transparent !important; }
}
</style>
